import * as types from "../../mutationTypes";
import priceListService from "services/priceListService";

const actions = {
  async setFilterCustomerId ({ commit }, customerId) {
    await commit(types.PRICELIST_CUSTOMER_FILTER, {
      customerId: customerId
    });
  },
  async findCurrent ({ state, commit }) {
    let customerId = state.filterCustomerId;
    if (!customerId) return;
    let priceList = await priceListService.findCurrent(customerId);
    await commit(types.PRICELIST_CURRENT, {
      priceList: priceList
    });
  },
  async clearCurrent ({ dispatch, commit }) {
    await dispatch('setFilterCustomerId', null);
    await commit(types.PRICELIST_CURRENT, {
      priceList: null
    });
  },
  async getAll ({ commit, state, dispatch}, force) {
    if (!state.items || state.items.length === 0 || force) {
      dispatch('app/loadingDataEnable', 'priceLists', {root: true});
      const priceLists = await priceListService.findAll();
      await commit(types.PRICELIST_LIST, {
        items: priceLists || []
      });
      dispatch('app/loadingDataDisable', 'priceLists', {root: true});
    }
  },
  async create ({dispatch, commit}, product) {
    try {
      let response = await priceListService.create(product);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  },
  async update ({dispatch, commit}, product) {
    let response = await priceListService.update(product);
    if (response.ok) {
      await dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async delete ({dispatch, commit}, id) {
    try {
      let response = await priceListService.delete(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/pricelist/priceListActions.js